//HOME page component
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE
//import $ from 'jquery'
//import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../components/heading'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import PageHeader from '../components/PageHeader'
//change the name of this to: BannerImage
import FullWidthImage from '../components/FullWidthImage'
import TextBlock from '../components/textblock'
import IndexBanner from '../components/IndexBanner'
import ContentSection from '../components/ContentSection'
import ContentBlock from '../components/ContentBlock'
import ImageBlock from '../components/ImageBlock'
import IndexCarousel from '../components/IndexCarousel'
import TextGrid from '../components/TextGrid'
import ColThreeBlock from '../components/ColThreeBlock'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************
const indexPage = ({data}) => {
    
    const home = data.home.edges
	
	
    return (  
        
        
        <div>  
            <Helmet>
                   <title>NJCCIC Home Page</title>
                     <meta name="description" content="The New Jersey Cybersecurity & Communications Integration Cell (NJCCIC) is the state's one-stop-shop for cyber threat analysis, incident reporting, and information sharing"/>
			<script defer src="/chatbot.js"type="text/javascript"></script>	
		    <script defer src="/heatmap.js"type="text/javascript"></script>	
            </Helmet>
        
            <Heading/>
            
            <Navbar/>
             
		
            {home.map(({ node: {seo_title, page_title, title, subtitle, content_group, call_to_action_text, content_grid, homepage_image, image_alt_text_primary, image, image_alt_text, content_blocks_c, carousel_content} }) => (
        
                    <div class="container-fluid">
        
                    
                        <IndexBanner src={homepage_image} style="bannerContent" subtitle={subtitle} data={carousel_content} />
                    
                        {/*INSERT CAROUSEL HERE*/}
                    
                        <ColThreeBlock divClass="container containerWidth" elementClass="col-12 col-lg-4 standardText blocks block3" dangerousClass="standardText blockText" headerStyles="header contentTitle" data={content_group}/>
                    
                        <div class="container containerWidth">
                            <TextBlock elementClass="col-12 textPadding topBorder bottomBorder" id='callToActionBlock' dangerousClass="callToAction bodyText" text={call_to_action_text}/>
                        </div>
        
                        <TextGrid elementClass="col-12 col-lg-6 col-xl-6 standardText block membersBlock blocks block3" headerStyles="header contentTitle" data={content_grid} dangerousClass="standardText blockText margin padding" imageClass="col-12 col-lg-7 col-xl-6" imageSrc={image} imageId="imagePadding"/>
                    
                        <FullWidthImage id="indexBanner" src={image} alt="Jersey City Hudson River Skyline"/>
                    
                        <Footer/>


                    </div>
                ))}   

					<div id="myModal" class="modal fade">
						<div class="modal-dialog">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Help Us Improve the NJCCIC Website!</h5>
									<button type="button" class="close" data-dismiss="modal">&times;</button>
								</div>
								<div class="modal-body">
									<p>Our website will be undergoing changes to better serve our members and the public. Please take a moment to complete our short <a href="https://bz7bkbm6.optimalworkshop.com/questions/0508a3e0738c48e1b60875a43cef7d7a">survey</a> to tell us what you would like to see on the new website and how it can be improved. The survey takes less than five minutes to complete and will help us provide a better digital experience for all.</p>
									<p>We greatly appreciate your time and input!</p>
									<p>Thank you!</p>
								</div>
							</div>
						</div>
					</div>
        </div>
        
    )
}
//*******************************************************************
//*******************************************************************
export const query = graphql`
    query {
        home: allButterPage(filter: { slug: { eq: "index" } }) {
            edges {
                node {
                    seo_title
                    subtitle
                    title
                    page_title
                    content_group {
                        section_name
                        text
                        icon
						icon_alt_text
                    }
                    homepage_image
                    
                    call_to_action_text
                    call_to_action_url
                    content_grid {
                        section_name
                        text
                        icon
						icon_alt_text
                    }
                    image
                    image_alt_text_primary
                    content_blocks_c {
                        title
                        text                        
                        button_text_a
                        button_a_url
                        button_text_b
                        button_b_url
                        button_text_c
                        button_c_url
                    }
                    carousel_content {
                        caption 
                        url
                        background_image
						background_image_alt_text
                    }
                }
            }
        }
        allButterCollection(filter: { id: { eq: "internal_navbar_links" } }) {
            edges {
                node {
                    id
                    value {
                        child_items {
                            label
                            url
                        },
                        url,
                        label,
                    }
                }
            }
        }
    }
`
export default indexPage
//*******************************************************************
//*******************************************************************